import React from 'react';
import Link from 'gatsby-link';
import classNames from 'classnames';
import { withPrefix } from 'gatsby';
import styles from './MainNavigation.styles';

const MainNavigation = ({ articles, locationPathName }) => (
  <div css={styles}>
    <div className="main-navigation">
      {articles &&
        articles.map((article) =>
          article.dropDownList ? (
            <div
              key={article.name}
              className={classNames('article-link', {
                'article-link--active': article.dropDownList
                  .map((item) => locationPathName === withPrefix(item.href))
                  .includes(true),
              })}>
              {article.name}
              {article.dropDownList && <p className="article-link__arrow" />}
              {article.dropDownList && (
                <div className="dropdown-content-wrapper">
                  <div className="dropdown-content">
                    {article.dropDownList.map((dropDownItem) => (
                      <div className="dropdown-content__link-wrapper" key={dropDownItem.href + dropDownItem.title}>
                        {dropDownItem.title ? (
                          <Link to={dropDownItem.href} className="dropdown-content__link-title">
                            {dropDownItem.title}
                          </Link>
                        ) : (
                          <Link
                            to={dropDownItem.href}
                            className={classNames('dropdown-content__link', {
                              'dropdown-content__link--active': locationPathName === withPrefix(dropDownItem.href),
                            })}>
                            {dropDownItem.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Link
              key={article.href}
              to={article.href}
              className={classNames('article-link', {
                'article-link--active': locationPathName === withPrefix(article.href),
              })}>
              {article.name}
            </Link>
          )
        )}
    </div>
  </div>
);

export default MainNavigation;
